import BaseClient from './baseClient';

type ForceUpdateRequest = {
  globalProductId: string;
  consumerChannelId: string;
};

type ForceUpdateByQueryRequest = {
  productCode?: string;
  globalProductId?: string;
  consumerChannelId: string;
};

const buildSingleProductQuery = (
  productCode: string,
  globalProductId: string,
  consumerChannelId: string,
) => {
  const query: Record<string, any> = {
    bool: {
      must: [{ term: { marketplace: 'CN' } }],
    },
  };
  if (consumerChannelId) {
    query.bool.must.push({ term: { consumerChannelId: consumerChannelId } });
  }
  if (productCode) {
    query.bool.must.push({ term: { productCode: productCode } });
  } else if (globalProductId) {
    query.bool.must.push({ term: { globalProductId: globalProductId } });
  } else {
    throw new Error('Either productCode or globalProductId must be provided');
  }
  return query;
};

class ConsumerProductProcessorClient extends BaseClient {
  async forceUpdate(payload: ForceUpdateRequest): Promise<void> {
    return this.fetch('/proxy/search/consumerproductprocessor/v1/forceUpdate', {
      method: 'POST',
      body: JSON.stringify({
        marketplace: 'CN',
        locationId: '09466143-84be-4c4f-9188-cc9a535cb8cd',
        language: 'zh-hans',
        ...payload,
      }),
    });
  }

  async forceUpdateByQuery(payload: ForceUpdateByQueryRequest): Promise<void> {
    const query = buildSingleProductQuery(
      payload.productCode || '',
      payload.globalProductId || '',
      payload.consumerChannelId,
    );
    return this.fetch(
      '/proxy/search/consumerproductprocessor/v1/forceUpdateByQuery',
      {
        method: 'POST',
        body: JSON.stringify({
          batchSize: 5,
          maxProducts: 5,
          dryRun: false,
          query,
        }),
      },
    );
  }
}

export default new ConsumerProductProcessorClient();
